module.exports = __webpack_public_path__ + "img/1493661677.007dcb88.jpg";